import React from 'react';
import TaskItemReward from '../TaskItemReward/TaskItemReward';
import TaskItemSign from '../TaskItemSign/TaskItemSign';
import TaskItemTitle from '../TaskItemTitle/TaskItemTitle';
import TaskItemText from '../TaskItemText/TaskItemText';
import TaskItemPremiumPrize from '../TasktemPremiumPrize/TaskItemPremiumPrize';
import TaskItemFooter from '../TaskItemFooter/TaskItemFooter';
import TaskItemWrapper from '../TaskItemWrapper/TaskItemWrapper';

const TaskItem = React.forwardRef(function ({ index, taskCallback, className, quest, children }, ref) {
  return (
    <TaskItemWrapper quest={quest} className={className} index={index}>
      <TaskItemSign quest={quest} />
      <TaskItemReward quest={quest} />

      <div className={'task__item-content'}>
        <TaskItemTitle quest={quest} />
        <TaskItemText quest={quest} />
        <TaskItemPremiumPrize quest={quest} />
        <TaskItemFooter quest={quest} taskCallback={taskCallback} />
      </div>
      {children}
    </TaskItemWrapper>
  );
});

export default TaskItem;
